import { DatePickerInput } from '#atoms';
import { formatKoreanDate } from '#pages/DashboardCustomerMembership/utils';

interface ExpiryDateProps {
  expiryDate: string | null | undefined;
  isCustom?: boolean;
  onChange: (date: Date) => void;
}

const ExpiryDate = ({
  expiryDate,
  onChange,
  isCustom = false
}: ExpiryDateProps) => {
  if (isCustom) {
    return (
      <div className="flex gap-4 items-center">
        <DatePickerInput
          date={expiryDate ? new Date(expiryDate) : new Date()}
          required
          title="개시 날짜 선택"
          onChange={onChange}
        >
          <div className="h-[37px] px-16 py-8 bg-[#2e2a3a] rounded-lg justify-center items-center gap-1 inline-flex">
            <div className="text-[#d7d2de] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
              {formatKoreanDate(expiryDate)}
            </div>
          </div>
        </DatePickerInput>
      </div>
    );
  }

  return (
    <div className="text-[#bcb8c3] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
      {expiryDate ? formatKoreanDate(expiryDate) : '없음'}
    </div>
  );
};

export default ExpiryDate;
